import { render } from "./FooterComponent.vue?vue&type=template&id=d22ffefe"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rioschan/Downloads/event-2022kikkoman-main/vue-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__